import React, { useState, useEffect } from 'react';
import useInfiniteScroll from './useInfiniteScroll';
import FavStar from './FavStarUsdt';
import { TableCell, TableRow } from '@mui/material';
import { showPairNameUsdt } from '../../../core/helper/date-format';

const DataTableUsdt = ({ data, loadMoreData, handleNavigation, updateFavPairs, favs, pairDetails, countDecimals }) => {
    const [visibleData, setVisibleData] = useState([]);
    const [page, setPage] = useState(0);
    const itemsPerPage = 10;

    // useEffect(() => {
    //     setVisibleData(()=>data)
    // }, []);
    // console.log(data)
    useEffect(() => {
        setVisibleData(data.slice(0, (page + 1) * itemsPerPage));
    }, [data, page]);

    const lastElementRef = useInfiniteScroll(() => {
        if (visibleData.length < data.length) {
            setPage((prevPage) => prevPage + 1);
        }
        loadMoreData();
    });
    return (
        <>
            {visibleData.map((dataSingle, index) => {
                const { symbol, lastPrice, price24hPcnt } = dataSingle;
                const isLastElement = index === visibleData.length - 1;
                return (
                    <TableRow
                        sx={{ border: 0 }}
                        ref={isLastElement ? lastElementRef : null}
                        key={index}
                    >
                        <TableCell sx={{ lineHeight: 2, border: 0, color: '#FFFFFF', fontSize: '14px', cursor: 'pointer', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '5px', padding: '6px 0px' }}>
                            <FavStar updateFavPairs={updateFavPairs} symbol={symbol} favs={favs} dataSingle={dataSingle} />
                            <span onClick={() => handleNavigation(showPairNameUsdt(symbol, '-'))}>
                                {showPairNameUsdt(symbol)}
                            </span>
                        </TableCell>
                        <TableCell sx={{ lineHeight: 2, color: '#FFFFFF', border: 0, fontSize: '14px', padding: '6px 0px' }}>
                            {lastPrice}
                        </TableCell>
                        <TableCell className={`${(Number(price24hPcnt) * 100) > 0 ? 'color-green-futures' : 'color-red-futures'}`} sx={{ lineHeight: 2, border: 0, fontSize: '14px', padding: '6px 0px' }}>
                            {(Number(price24hPcnt) * 100).toFixed(2)}%
                        </TableCell>
                    </TableRow>
                );
            })}
        </>
    );
};

export default DataTableUsdt;

